import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import duck from './giraffe.glb'

const ThreeScene = () => {

    const sizes = {
        width: 300,
        height: 300,
    }

    const canvasRef = useRef(null); // Create ref for canvas
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer({ antialias: true });
    const controls = useRef(null);
    const modelRef = useRef(null);

    renderer.setClearColor(0x000000, 0); // transparent background



    useEffect(() => {
        // Camera, render, controls sets
        camera.position.z = 3;
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(window.devicePixelRatio);
        canvasRef.current.appendChild(renderer.domElement);
        controls.current = new OrbitControls(camera, renderer.domElement);
        controls.current.enableDamping = true;

        // Load model
        const loader = new GLTFLoader();
        loader.load(duck, (glb) => {
            const model = glb.scene;
            model.scale.set(0.03, 0.03, 0.03);
            model.position.set(0, 0, 0);
            model.rotation.y = Math.PI;
            model.rotation.x = 0.25;
            scene.add(model);

            modelRef.current = model;
        })

        // Light
        const hemiLight = new THREE.HemisphereLight(0xffe4b5, 0xcd853f, 0.61);
        hemiLight.position.set(0, 50, 0);
        scene.add(hemiLight);

        const dirLight = new THREE.DirectionalLight(0xffffe0, 0.54);
        dirLight.position.set(-8, 12, 8);
        dirLight.castShadow = true;
        dirLight.shadow.mapSize = new THREE.Vector2(1024, 1024);
        scene.add(dirLight);


        const animate = () => {
            requestAnimationFrame(animate);
            
            if(modelRef.current){
                modelRef.current.rotation.y += 0.005;
            }
            controls.current.update();
            renderer.render(scene, camera);
        };

        animate();

        // component did unmount
        return () => {
            controls.current.dispose();
            renderer.domElement.remove();
        };
    }, []);

    useEffect(() => {
        // Optimize giraffe for the screen resizes
        const handleResize = () => {
            camera.aspect = sizes.width / sizes.height;
            camera.updateProjectionMatrix();
            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
            renderer.render(scene, camera);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

  return <div className='cursor-pointer' ref={canvasRef} />;
};

export default ThreeScene;
